<template>
    <v-row justify="space-around">
      <v-col cols="auto">
        <v-dialog
          transition="dialog-top-transition"
          width="820px"
          v-model="dialog"
          scrollable="false">
          <template v-slot:default="{ isActive }">
            <v-card color="transparent">
            <v-card-title class="justify-end headline" @click="dialog = false" style="cursor:pointer; font-weight:bold;">X</v-card-title>
              <v-card-text>
                    <v-img
                      height="100%"
                      contain
                      src="@/assets/pages/openfest/modal_openfest.png"
                      style="cursor:pointer"
                      @click="redirect()">
                    </v-img>
              </v-card-text>
              <v-card-actions class="justify-end">
                <!-- <v-btn
                  variant="text"
                  @click="dialog = false"
                >Close</v-btn> -->
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>
  </template>

<script>
export default {
  data () {
    return {
      dialog: true
    }
  },
  methods: {
    redirect: function(){
        window.open("https://www.columbia.edu.pe/openfest", '_self')
    }
  }
}
</script>